export const defaultFun = () => {}
export const formattingNumber = function(number) {
    const regex = /\B(?=(\d{3})+\b)/g;
    number = Number(number)
    return number.toFixed(2).replace(regex, ',')
}

// 为某个节点添加class
export const concatClass = (node, className) => {
    const header_tr_class = (node.getAttribute('class') || '').concat(` ${className}`)
    node.setAttribute('class', header_tr_class)
}

// 为fix节点添加width
export const rewriteStyle = (node, width) => {
    const ex_key = {
        width: true,
        'min-width': true
    }
    let header_th_style = node.getAttribute('style') || ''
    const new_header_th_styles = []
    header_th_style = header_th_style.split(';')
    header_th_style.forEach(style => {
        const style_clone = style.split(':')
        if (ex_key[style_clone[0].trim()] || !style.trim()) {
            return 
        }
        new_header_th_styles.push(style)
    })
    new_header_th_styles.push(`width:${width}px`)
    // node.setAttribute('style', new_header_th_styles.join(';'))
}

export const setLeft = (node, left) => {
    let header_tr_style = node.getAttribute('style').trim()
    if (!header_tr_style) {
        header_tr_style = `left:${left}px`
    } else {
        header_tr_style = `${header_tr_style};left:${left}px`
    }
    node.setAttribute('style', header_tr_style)
}

export const setRight = (node, right) => {
    let header_tr_style = node.getAttribute('style').trim()
    if (!header_tr_style) {
        header_tr_style = `right:${right}px`
    } else {
        header_tr_style = `${header_tr_style};right:${right}px`
    }
    node.setAttribute('style', header_tr_style)
}

export const getVariateTypeCompare = (source, target) => {
   return Object.prototype.toString.call(source) === target
}